import React, {useEffect} from "react";
import TotalDataComponent from "../../../components/total-data.component";
import PointList from "./point-list";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {setToolsInitialState} from "../../../reducers/tools.reducer";

const TabPoint = () => {
    const dispatch = useDispatch()
    const {id} = useParams()
    const {currentPage, pageSize} = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
    }
    const {data: response, fetching: getLoyaltyPointList, isLoading} = useFetch({...API.USER_LOYALTY_POINT_LIST, ...{initPathVariable: id}}, queryParams, {isWithTotalData: true})

    useEffect(() => {
        getLoyaltyPointList()
    }, [currentPage, id])

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
        }
    }, [])

    return (
        <div className={"px-10 space-y-5"}>
            <TotalDataComponent subject={"riwayat point"}/>
            <PointList dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default TabPoint
